<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="getSearch(1)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
        :clearable="true"
      ></el-input>
      <el-input
        @keyup.enter.native="getSearch(1)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入证书id"
        size="small"
        v-model="listQuery.userCertId"
        :clearable="true"
      ></el-input>
      <el-select
        @keyup.enter.native="getSearch(1)"
        v-model="listQuery.certId"
        clearable
        placeholder="请选择证书类型"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in listStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getSearch(1)" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="closeData"
    >
      <el-table-column align="center" label="证书id">
        <template slot-scope="scope">
          <span class="rowId" @click="getRow(scope.row.id)">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证书类型id">
        <template slot-scope="scope">
          <span>{{ scope.row.certId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证书类型名称">
        <template slot-scope="scope">
          <span>{{ scope.row.certName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户id">
        <template slot-scope="scope">
          <span>{{ scope.row.accountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户 (自己) 昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="对方昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.inviteeNickname }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCont(scope.row.id)"
            v-permission:function="['certificateListDManger:btn_cont']"
            style="margin-top: 10px;"
          >获取基础属性</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
    <el-dialog title="基础属性" :visible.sync="centerDialogVisible" width="80%" center>
      <el-table
        size="small"
        :key="tableKey"
        stripe
        border
        highlight-current-row
        style=" margin-top: 20px"
        :data="baseList"
      >
        <el-table-column align="center" label="id">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="图标">
          <template slot-scope="scope">
            <img style="width:97px;height:97px" :src="scope.row.icon" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="影响值">
          <template slot-scope="scope">
            <span>{{ scope.row.value }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="介绍">
          <template slot-scope="scope">
            <span>{{ scope.row.subtitle }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="240">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click="delCont(scope.row.id,scope.row.name,scope.row.value)"
              :disabled="scope.row.value == 0 ? true :false"
              style="margin-top: 10px;"
            >扣除基础属性</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="attribute" :visible.sync="deduction" width="40%" center>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="属性值" required prop="value">
          <el-input-number v-model="form.value" :step="1" :min="0" :max="val" size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deduction = false">取 消</el-button>
        <el-button type="primary" @click="getDetermine">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { userCerts, getAttrBase, getBaseSet } from '@/api/demo/certificateList/index'
import { certList } from '@/api/demo/close/index'
export default {
  name: 'certificateListDManger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      baseList: [], // 基础属性集合
      listQuery: {
        accountId: '', // 用户id
        certId: '', // 证书类型
        userCertId: '', // 证书id
        currentPage: 1,
        pageSize: 20
      },
      listStatus: [],
      listS: {
        currentPage: 1,
        pageSize: 20
      },
      closeData: [], // 数据
      total: null,
      centerDialogVisible: false, // 获取基础属性
      deduction: false, // 扣除基础属性
      val: null,
      form: {
        attrId: null, // 账户
        remark: '', // 增加属性成长值
        userCertId: null, // 用户亲密证书id
        value: 0 // 增加属性成长值
      },
      attribute: '',
      rules: {},
      certId: null
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {
    let that = this
    certList(that.listS).then(res => {
      that.listStatus = res.records
    })
  },
  mounted () {
    this.getSearch()
  },
  methods: {
    // 搜索条件
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      userCerts(that.listQuery).then(res => {
        that.listLoading = true
        that.closeData = res.records
        console.log(that.$data, that.$options.data())
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    // 获取基础属性
    editCont (id) {
      let that = this
      let data = { userCertId: id }
      that.certId = id
      getAttrBase(data).then(res => {
        that.listLoading = true
        that.baseList = res
        that.centerDialogVisible = true
        that.listLoading = false
      })
      // this.$router.push({
      //   path: "./certificateList/baseList",
      //   query: {
      //     id: id
      //   }
      // });
    },
    // 扣除基础属性
    delCont (id, name, val) {
      let that = this
      // if (this.certId == null) {
      //   let that = this;
      //   that.$router.push({
      //     path: "../../demo/certificateList"
      //   });
      //   return false;
      // }
      that.val = val
      that.attribute = name
      that.form.attrId = id
      that.form.userCertId = that.certId
      that.centerDialogVisible = false
      that.deduction = true
    },
    // 扣除
    getDetermine (id) {
      let that = this
      that
        .$confirm('此操作将永久扣除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          getBaseSet(that.form).then(() => {
            that.getSearch()
            that.$notify({
              title: '成功',
              message: '扣除成功',
              type: 'success',
              duration: 2000
            })
            let data = { userCertId: that.certId }
            getAttrBase(data).then(res => {
              that.listLoading = true
              that.baseList = res
              that.centerDialogVisible = true
              that.listLoading = false
            })
            that.deduction = false
            that.centerDialogVisible = true
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消扣除'
          })
          that.deduction = false
          that.centerDialogVisible = true
        })
    },
    // 跳转到影响力审核
    getRow (id) {
      let that = this
      that.$router.push({
        path: '../../demo/examineList',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.rowId {
  cursor: pointer;
  color: rgb(64, 158, 255);
}
</style>
